import { useEffect, useState } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { nanoid } from "nanoid/non-secure";

import serialize from "./serialize";

const busMap = {};

const deserialize = dataString => eval(`(${dataString})`);

const getBus = (key: string) => {
    let bus = busMap[key];

    if (!bus) {
        bus = {
            triggers: [],
        };

        busMap[key] = bus;
    }

    return bus;
};

const register = (id: string, key: string, setFn: (value: any) => any) => {
    const bus = getBus(key);

    const trigger = {
        id,
        setFn,
    };

    bus.triggers.push(trigger);

    const unsubFn = () => {
        bus.triggers = bus.triggers.filter(trigger => trigger.id !== id);
    };

    return unsubFn;
};

const triggerUpdates = (key: string, value: any) => {
    const bus = getBus(key);

    bus.triggers.forEach(trigger => trigger.setFn(value));
};

export const useStorage = key => {
    const [_item, _setItem] = useState(null);
    const [_id] = useState(nanoid());

    useEffect(() => {
        const unsubFn = register(_id, key, _setItem);

        return unsubFn;
    }, []);

    const getItem = async () => {
        const dataString = await AsyncStorage.getItem(key);
        const item = deserialize(dataString);

        _setItem(item);
    };

    const setItem = item => {
        const dataString = serialize(item);

        AsyncStorage.setItem(key, dataString);
        triggerUpdates(key, item);

        return item;
    };

    const clearItem = () => {
        AsyncStorage.removeItem(key);
        triggerUpdates(key, null);
        _setItem(null);
    };

    useEffect(() => {
        getItem();
    }, []);

    return [_item, setItem, clearItem];
};

export default useStorage;
